




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import PGRowStringValue from '@/components/common/property/PGRowStringValue.vue';
import PGRowIntValue from '@/components/common/property/PGRowIntValue.vue';
import PGRowDateValue from '@/components/common/property/PGRowDateValue.vue';
import PGRowUIPageValue from '@/components/common/property/PGRowUIPageValue.vue';
import PGRowBooleanValue from '@/components/common/property/PGRowBooleanValue.vue';
import PGRowBindingBEAttributeValue from '@/components/common/property/PGRowBindingBEAttributeValue.vue';
import PGRowEnumValue from '@/components/common/property/PGRowEnumValue.vue';
import PGRowDataTypeValue from '@/components/common/property/PGRowDataTypeValue.vue';
import { EnumDataType } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import PGRowAPPValue from '@/components/common/property/PGRowAPPValue.vue';
import PGRowWorkScopeValue from '@/components/common/property/PGRowWorkScopeValue.vue';
import PGRowActionTypeValue from '@/components/common/property/PGRowActionTypeValue.vue';
import { EnumBEType } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import PGRowBusinessLogicValue from './PGRowBusinessLogicValue.vue';
import PGRowExternalServiceValue from './PGRowExternalServiceValue.vue';
import PGRowAccountValue from './PGRowAccountValue.vue';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';

@Component({
  components: {
    PGRowStringValue,
    PGRowIntValue,
    PGRowDateValue,
    PGRowUIPageValue,
    PGRowBooleanValue,
    PGRowEnumValue,
    PGRowDataTypeValue,
    PGRowAPPValue,
    PGRowWorkScopeValue,
    PGRowActionTypeValue,
    PGRowBusinessLogicValue,
    PGRowExternalServiceValue,
    PGRowBindingBEAttributeValue,
    PGRowAccountValue
  }
})
export default class PGRow extends Vue {
  @Prop() displayName!: string;
  @Prop() value!: any;
  @Prop() type!: EnumDataType; // 元元数据类型：当前行接受的值的数据类型，比如：referenceType的类型是string
  @Prop() dataType!: EnumDataType | null; // 元数据类型：当前属性的数据类型，如果不是属性则为null，比如：属性的数据类型是Reference
  @Prop() name!: string;
  @Prop() elementDesignId!: string;
  @Prop() isEditable!: boolean;
  @Prop() description?: string;
  @Prop() refType?: string;
  @Prop() isBrowsable!: boolean;
  @Prop() customDesigner!: string; // 自定义属性设计器

  get beType() {
    return EnumBEType;
  }

  isString(): boolean {
    return this.type === EnumDataType.String;
  }

  isText(): boolean {
    return this.type === EnumDataType.Text;
  }

  isNumber(): boolean {
    return this.type === EnumDataType.Int;
  }

  isDateTime(): boolean {
    return this.type === EnumDataType.DateTime;
  }

  isBoolean(): boolean {
    return this.type === EnumDataType.Bool;
  }

  isReference(): boolean {
    return this.dataType === EnumDataType.Reference;
  }

  valueChanged(newValue: any, newElement: BaseElement): void {
    this.$emit('valueChanged', this.elementDesignId, this.name, newValue, null);
  }

  valueObjChanged(newValue: string, newElement: BaseElement): void {
    this.$emit('valueChanged', this.elementDesignId, this.name, newValue, newElement);
  }

  rowClick(): void {
    this.$emit('rowClick', this.description);
  }

  get curAPP() {
    const component = this.$store.state.ModuleMD.curComponent as BaseComponent;
    // console.log(component);
    if (component && component.aPP_ID !== null) {
      const findAPP = this.$store.state.ModuleMD.apps.find((item: APP) => item.id === component.aPP_ID);
      if (findAPP) {
        return findAPP;
      }
    }
    return null;
  }
}
